import { IB_REPO_VERIFY_ROLES } from '../properties/ib-repo-verification.properties';

/**
 * Tells if a user with this role can verify the IB repo hours.
 */
export function canVerifyIbRepo(role: string | null | undefined): boolean {
  return Boolean(role) && IB_REPO_VERIFY_ROLES.includes(role as string);
}
